// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const Factory = t.struct( {
    factoryCode: t.String,
    factoryDescription: t.String,
}, {
    name: 'Factory',
    strict: true,
} );

export const getDefaultState = () => new Factory( {
    factoryCode: '',
    factoryDescription: '',
} );

export default Factory;
